"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var Box_1 = require("../Box");
var TableCell_1 = require("../TableCell");
var TableFooter_1 = require("../TableFooter");
var TableRow_1 = require("../TableRow");
var Cell_1 = require("./Cell");
var StyledDataTable_1 = require("./StyledDataTable");
var Footer = function (_a) {
    var columns = _a.columns, footerValues = _a.footerValues, groups = _a.groups, theme = _a.theme, rest = tslib_1.__rest(_a, ["columns", "footerValues", "groups", "theme"]);
    return (React.createElement(StyledDataTable_1.StyledDataTableFooter, tslib_1.__assign({ as: TableFooter_1.TableFooter }, rest),
        React.createElement(TableRow_1.TableRow, null,
            groups && (React.createElement(TableCell_1.TableCell, { size: "xxsmall", plain: true, verticalAlign: "top" },
                React.createElement(Box_1.Box, tslib_1.__assign({}, tslib_1.__assign(tslib_1.__assign({}, theme.table.footer), theme.dataTable.footer))))),
            columns.map(function (column) { return (React.createElement(Cell_1.Cell, { key: column.property, context: "footer", column: column, datum: footerValues })); }))));
};
var FooterWrapper = recompose_1.compose(styled_components_1.withTheme)(Footer);
exports.Footer = FooterWrapper;
//# sourceMappingURL=Footer.js.map